<template lang="pug">
  //- form内にある前提
  //- ドロップエリア
  div.bcard-file
    app-messages(v-show="edit_mode", :errorMessages="errmsgs")

    //- ドロップエリア
    .bcard-file-droppable(@dragover="edit_mode ? dragover($event) : null", @drop="edit_mode ? drop($event) : null", @dragleave="edit_mode ? dragleave($event) : null", :class="{'-droppable': edit_mode, '-dragover': isHovered}")

      //- 表示画像index
      template(v-if="type === 'image'")
        input(type="hidden", name="image_index", :value="mainImageIndex")

      //- 削除画像ID
      input(v-for="sid_attach in del_images",
        :key="sid_attach",
        type="hidden",
        name="image_dels[]"
        :value="sid_attach"
      )

      //- スライド
      .slide#jbcard-file-droppable-slide(v-show="slides.length > 0")

        //- ナビゲーション
        ol.carousel-indicators(v-if="multi")
          li(v-for="(slide, index) in slides",
            :key="index",
            :class="getNavItemClassName(index)",
            @click="slideTo($event, index)")

        //- スライド
        .carousel-inner(role='listbox')
          .item(v-for="(slide, index) in slides",
            :key="index",
            :class="getSlideItemClassName(index)"
          )
            //- loadingと404画像以外、新規も既存も回転できる
            input(v-if="type === 'image'",
              type="hidden",
              :name="'images[' + index + '][rotate]'",
              :value="slide.rotate")

            //- 新規
            template(v-if="slide.isNew")
              template(v-if="type === 'image'")
                input(type="hidden",
                  :name="'images[' + index + '][is_new]'",
                  :value="app_flag.ON")
                input(type="hidden",
                  :name="'images[' + index + '][file_index]'",
                  :value="slide.file_index")
              //- 画像ファイル
              img.image.zoomable(v-if="slide.dataURL", :src="slide.dataURL", :alt="slide.name", :ref="'image_' + index", @click="zoom")
              //- その他ファイル
              .image(v-else)
                .icon {{slide.name.split('.').pop()}}
                .bcard-ui-userdata {{slide.name}}

            //- 既存
            template(v-else)
              template(v-if="type === 'image'")
                input(type="hidden",
                  :name="'images[' + index + '][is_new]'",
                  :value="app_flag.OFF")
                input(type="hidden",
                  :name="'images[' + index + '][sid_attach]'",
                  :value="slide.sid_attach")
              img.image.zoomable(v-if="slide.dataURL", :src="slide.dataURL", :alt="slide.name", :ref="'image_' + index", @click="zoom")
              img.image.zoomable(v-else, :src="app_imgsrc.now_loading", v-src="slide.vSrc", :alt="slide.name", :ref="'image_' + index", @click="zoom")

            template(v-if="index === activeIndex")
              template(v-if="edit_mode")
                template(v-if="type === 'image'")
                  .form-control-static.rep(v-if="mainImageIndex === index")
                    | メイン画像
                  a.rep.btn.btn-default(v-else, href="#", @click.prevent="rep($event, index)") メイン画像にする

                a.remove(href="#", @click.prevent="remove(index)", title="選択を解除する", data-testid="-remove-file")
                  i.fa.fa-times-circle.fa-2x
                a.rotate(v-if="slide.rotatable", href="#", @click.prevent="rotate(index)", title="画像を回転する")
                  i.fa.fa-retweet.fa-2x
              template(v-else)
                template(v-if="type === 'image'")
                  .form-control-static.rep(v-if="mainImageIndex === index")
                    | メイン画像

        //- 並び替え
        a.order(v-if="edit_mode && slides.length > 1", href="#", @click.prevent="openModalOrder", title="並び替え")
          i.fa.fa-exchange.fa-lg

      //- 画像無し
      .slide.none(v-if="slides.length === 0 && type === 'image'")
        .carousel-inner
          .item.active
            img.image(:src="app_imgsrc.no_image")

      label.message(v-show="edit_mode", :for="fileInputName")
        //- 画像の場合はメッセージが邪魔なので非表示にする
        template(v-if="type !== 'image'")
          p こちらへ{{fileTypes[type].text}}ファイルをドラッグ＆ドロップできます。
          p または
            span.sel-file ファイルを選択
            |
            | してください。
        input(
          type="file",
          ref="input",
          :name="fileInputName",
          :id="fileInputName",
          :multiple="!!multi",
          :accept="fileTypes[type].ext.join(',')",
          @change="inputChange",
          data-testId="-files"
        )

        //- requiredメッセージを表示するためのダミー
        input(type="text", :name="fileInputName + '_dummy'", :required="required", :value="dummyFile", autocomplete="off", tabindex="-1")

        //- 左右移動
        a.left.carousel-control(href="#jbcard-file-droppable-slide", :title="'前の' + fileTypes[type].text + 'へ'", v-show="isPrevActive", @click.prevent="slideTo($event, activeIndex - 1)")
          i.fa.fa-angle-left
        a.right.carousel-control(href="#jbcard-file-droppable-slide", :title="'次の' + fileTypes[type].text + 'へ'", v-show="isNextActive", @click.prevent="slideTo($event, activeIndex + 1)")
          i.fa.fa-angle-right

    .help-block(v-if="edit_mode || conf_mode")
      p.bcard-comments.text-info ※ こちらへ{{fileTypes[type].text}}ファイルをドラッグ＆ドロップするか、クリックしてファイルを選択してください。
      p.bcard-comments.text-info ※ 添付可能なファイルの拡張子は {{fileTypes[type].ext.join(', ')}} です。
      div.bcard-comments.text-info(v-if="sizeLimit") ※ 1 ファイル につき {{convertUnit(sizeLimit)}} までの{{fileTypes[type].text}}を添付してください。
      div.bcard-comments.text-info(v-if="numLimit") ※ {{numLimit}} 枚 までアップロードできます。

    app-modal(v-if="type === 'image'", type="default" v-model="modalOrder_isOpen")
      template(slot="title") 画像の並び替え
      .order-items-wrap
        ul.order-items(ref="orderItems")
          li.item(v-for="(slide, index) in slides", :key="index", :class="getSlideItemClassName(index)", :data-slide-index="index")
            //- 新規
            template(v-if="slide.isNew")
              //- 画像ファイル
              img.image(v-if="slide.dataURL", :src="slide.dataURL", :alt="slide.name")
              //- その他ファイル
              .image(v-else)
                .icon {{slide.name.split('.').pop()}}
                .bcard-ui-userdata {{slide.name}}
            //- 既存
            template(v-else)
              img.image(v-if="slide.dataURL", :src="slide.dataURL", :alt="slide.name", :ref="'image_' + index")
              img.image(v-else, :src="app_imgsrc.now_loading", v-src="slide.vSrc", :alt="slide.name", :ref="'image_' + index")
      template(slot="footer", slot-scope="{close}")
        .help-block.pull-left(v-if="edit_mode")
          .bcard-comments.text-info ※ ドラッグ＆ドロップで画像を入れ替えてください。
        button.btn.btn-primary(type="button", @click="order();close();") OK
        button.btn.btn-default(type="button", @click="close") キャンセル

</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import 'jquery-ui/ui/widgets/sortable'
import 'jquery-ui/themes/base/sortable.css'

/*
  this.images: すべてのファイル（表示順通りの配列）
    sid_attach: 画像ID（既存のみ）
    file_index: フォームデータのファイルインデックス（新規のみ）
  formData.files: 新規ファイルデータ（順不同）
  this.del_images: 削除する画像IDの配列
*/
export default {
  name: 'FileDroppable',
  components: { AppModal, AppMessages },
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }, // v-modelで指定したやつが入ってくる
    edit_mode: {type: [Boolean, null], required: false, default: false}, // 入力モード
    conf_mode: {type: [Boolean, null], required: false, default: false}, // 入力確認モード
    view_mode: {type: [Boolean, null], required: false, default: false}, // 表示モード
    multi: {type: Boolean, required: false, default: false}, // 複数選択するかどうか
    // files: {type: Array, required: false, default: []},
    name: {type: String, required: false, default: ''}, // default: file/files[]
    // slide: {type: Boolean, required: false, default: true}, // スライドで表示するかどうか
    required: {type: Boolean, required: false, default: false},
    type: {type: String, required: false, default: 'image'}, // image/csv
    mainImageId: {type: String, required: false, default: ''} // メイン画像にする画像ID
  },
  data () {
    return {
      fileTypes: {
        image: {
          text: '画像',
          // inputタグのacceptでも使用するため、「.」をつける
          ext: ['.jpeg', '.jpg']
        },
        csv: {
          text: 'CSV',
          // inputタグのacceptでも使用するため、「.」をつける
          ext: ['.csv']
        }
      },
      files: [],
      slides: [],
      del_images: [],
      isHovered: false,
      // hoverClass: '-dragover',
      activeIndex: 0, // スライドで表示中の画像index
      mainImageIndex: 0, // メイン画像にする画像index
      fileInputName: '_files',
      sizeLimit: null,
      numLimit: null,
      modalOrder_isOpen: false,
      errmsgs: [] // エラーメッセージ
    }
  },
  computed: {
    isPrevActive () {
      return this.activeIndex > 0
    },
    isNextActive () {
      return this.slides && this.activeIndex < this.slides.length - 1
    },
    dummyFile () {
      return this.files.length === 0 ? '' : 'dummyFile'
    }
  },
  watch: {
    value () {
      // mainImageIdもcreatedより後に変わるが、valueと同時に変わるので、watchはvalueだけにする
      this.initImage()
    },
    files (newValue) {
      this.$store.commit('setFiles', newValue)
    }
  },
  created () {
    // this.$store.commit('delFiles')
    this.$store.commit('setFiles', this.files)
    if (this.type === 'image') {
      this.numLimit = this.multi ? this.loadConfigEnv('NUM_BCARD_IMAGES_MAX_LIMIT') : 1
      this.sizeLimit = this.loadConfigEnv('NUM_BCARD_MAX_BYTE_PER_IMAGE')
    }
    this.initImage()
  },
  methods: {
    initImage () {
      this.slides = []

      let image
      // 初期データがあった場合の処理
      for (let index = 0, len = this.value.length; index < len; index++) {
        image = this.value[index]
        // メイン画像IDをindexに変換する
        if (this.mainImageId === image.sid_attach) {
          this.activeIndex = index
          this.mainImageIndex = index
        }

        // スライド画像に変換
        this.slides.push({
          isNew: false,
          sid_attach: image.sid_attach,
          name: image.name,
          vSrc: image.image_url
        })
      }
      // watchできないので手動フック
      // サーバーから取得したdataURLを保存しておく（タイミングが合わないものはあきらめる）
      if (this.slides.length) {
        const start = +(new Date())
        const intvl = setInterval(() => {
          this._setDataUrl()
          let countDataURL = 0
          for (let slide of this.slides) {
            if (slide.dataURL) {
              countDataURL++
              // loadingが終わった404以外の画像（dataURL形式）は回転可能と判断する
              slide.rotatable = slide.dataURL.substr(0, 4) === 'data'
            }
          }
          if (this.slides.length === countDataURL || +(new Date()) - start > 3000) {
            this.$forceUpdate() // rotateアイコンを出すため
            clearInterval(intvl)
          }
        }, 100)
      }
    },
    // 入力：ドロップエリア
    // ブラウザ上でファイルを開かないようにしておく
    _notToOpenFile (e) {
      e.stopPropagation()
      e.preventDefault()
    },
    // エリア内にドラッグされたとき
    dragover (e) {
      // ブラウザ上でファイルを開かないようにしておく
      this._notToOpenFile(e)
      this.isHovered = true
    },
    // エリア外にドラッグされたとき
    dragleave (e) {
      this.isHovered = false
    },
    // エリア内にドロップされたとき
    drop (e) {
      const files = e.target.files || e.dataTransfer.files
      // ブラウザ上でファイルを開かないようにしておく
      this._notToOpenFile(e)
      this.isHovered = false
      this.setFiles(files)
    },
    /**
     * ファイルが更新されたときのイベント
     * @param e イベント
     */
    inputChange (e) {
      // ファイルの情報を取得
      // ファイル選択ダイアログで「キャンセル」を押すと空配列が返ってくる
      const files = e.target.files || e.dataTransfer.files
      // ファイル選択ダイアログで「キャンセル」を押した場合は何もしない
      if (files.length === 0) {
        return
      }
      this.setFiles(files)
      this.$refs.input.value = '' // 同名ファイルを再選択できるようにする
    },
    setFiles (files) {
      this.errmsgs = []

      // 単数選択の場合、画像入れ替え
      if (!this.multi) {
        this.files = []
        this.slides = []
      }
      // スライド画像更新
      const indexOffset = this.files.length
      for (let i = 0, len = files.length; i < len; i++) {
        // ファイルサイズチェック
        let ret = this.checkFileSize(files[i], this.sizeLimit)

        if (ret !== true) {
          // indexによってメッセージを出し分ける
          let index = (this.slides.length + i + 1)
          let indexMessage = index + '番目以降の'
          if (index === 1) {
            indexMessage = '選択した'
          }
          // エラーメッセージを設定する
          if (ret === -1) {
            this.errmsgs.push('0バイトのファイルが含まれていたため、' + indexMessage + 'ファイルは添付できませんでした。')
          }
          else if (ret === -2) {
            this.errmsgs.push('ファイルサイズ上限を超えるファイルが含まれていたため、' + indexMessage + 'ファイルは添付できませんでした。')
          }
          break
        }

        this.files.push(files[i])
        this._pushImage(files[i], indexOffset + i)
        // 2件目以降を廃棄
        if (!this.multi) {
          break
        }
      }
    },
    // 代表画像にする
    rep (e, index) {
      this.mainImageIndex = index
    },
    remove (index) {
      const del_image = this.slides[index]

      // 新規の場合、送信するファイルを削除
      if (del_image.isNew) {
        this.files.splice(del_image.file_index, 1)
        // index調整
        for (let i = 0, len = this.slides.length; i < len; i++) {
          if ('file_index' in this.slides[i] && this.slides[i].file_index > del_image.file_index) {
            this.slides[i].file_index--
          }
        }
      }
      // 既存の場合、サーバーのファイルを削除
      else {
        this.del_images.push(del_image.sid_attach)
      }

      // スライド画像更新
      this.slides.splice(index, 1)

      // activeIndex更新
      // 最後の消したら、activeを1つ前のものに移す（0ならそのまま）
      if (index > 0 && index === this.slides.length) {
        this.activeIndex = index - 1
      }
      // メイン画像を消したら0番目をメイン画像にする
      if (index === this.mainImageIndex) {
        this.mainImageIndex = 0
      }
      // index繰上げ
      else if (index < this.mainImageIndex) {
        this.mainImageIndex--
      }
    },
    /**
     * 回転できる画像は以下を満たす
     * ・画像である（this.type === 'image'）
     * ・loading画像が終わっている（slide.dataURLがある）
     * ・404画像ではない（slide.dataURLがパス指定）
     * ・新規画像または既存画像（slide.dataURLがdataから始まる）
     */
    rotate (index) {
      const slide = this.slides[index]
      slide.rotate = slide.rotate || 0

      // 右に回転させる（+90度）
      slide.rotate = (slide.rotate + 90) % 360

      // CSS調整描画
      const $wrapper = this.$refs['image_' + index][0].parentElement
      $wrapper.classList.remove('rotating') // IEは複数指定できない
      $wrapper.classList.remove('rotating-90')
      $wrapper.classList.remove('rotating-180')
      $wrapper.classList.remove('rotating-270')
      if (slide.rotate !== 0) { // IEはtoggleを使えない
        $wrapper.classList.add('rotating')
        $wrapper.classList.add('rotating-' + slide.rotate)
      }

      this.$forceUpdate() // rotateのhidden値が反映されないので
    },
    zoom (e) {
      const dataUrl = $(e.target).attr('src')
      const win = window.open('about:blank')
      win.document.write('<img src="' + dataUrl + '"/>')
      win.document.close()
    },
    /**
     * 画像を入れ替えるモーダルを立ち上げる
     */
    openModalOrder () {
      const vm = this
      this.modalOrder_isOpen = true
      this.$nextTick(function () {
        $(vm.$refs.orderItems).sortable({
          axis: 'x', // 横方向のみ
          cursor: 'move',
          forceHelperSize: true,
          forcePlaceholderSize: true,
          placeholder: 'item sortaable-chosen',
          scroll: false
        })
      })
    },
    /**
     * 入れ替えた画像の順番をコミットする
     */
    order () {
      let orderedSlides = []
      for (let item of this.$refs.orderItems.children) {
        orderedSlides.push(this.slides[item.dataset.slideIndex])
      }

      // メイン画像index調整
      this.mainImageIndex = orderedSlides.indexOf(this.slides[this.mainImageIndex])

      this.slides = orderedSlides
    },
    // moveToLeft (e, index) {
    //   this.moveTo(index, index - 1)
    // },
    // moveToRight (e, index) {
    //   this.moveTo(index, index + 1)
    // },
    // moveTo (index, newIndex) {
    //   let tmp

    //   // watchできないので手動フック
    //   this._setDataUrl()

    //   // スライド画像更新
    //   tmp = this.slides[index]
    //   this.slides[index] = this.slides[newIndex]
    //   this.slides[newIndex] = tmp

    //   // 表示中画像ID調整
    //   // 隣通しの画像を入れ替えても現在位置は変えないようにするのでコメントアウト
    //   // if (this.activeIndex === index) this.activeIndex = newIndex
    //   // else if (this.activeIndex === newIndex) this.activeIndex = index

    //   // メイン画像ID調整
    //   if (this.mainImageIndex === index) this.mainImageIndex = newIndex
    //   else if (this.mainImageIndex === newIndex) this.mainImageIndex = index

    //   // 入れ替えた要素にメイン画像が含まれていないと見た目が更新されないので強制的に更新する
    //   this.$forceUpdate()
    // },
    // dataURLを再リクエストしないように、dataURL取得済みの場合は保存しておく
    _setDataUrl () {
      for (let i = 0, len = this.slides.length; i < len; i++) {
        let elImg = this.$refs['image_' + i]
        if (elImg && elImg.length && elImg[0].src.substr(0, 4) === 'data') {
          this.slides[i].dataURL = elImg[0].src
        }
      }
    },
    _pushImage (file, file_index) {
      const vm = this
      // 画像は元ファイルからサムネイルを作成する
      if (this.type === 'image') {
        let reader = new FileReader()
        reader.onload = function (e) {
          vm.slides.push({
            isNew: true,
            file_index: file_index,
            dataURL: e.target.result,
            name: file.name,
            size: file.size,
            rotatable: true // 新規画像は404になりようがないので、回転可能とする
          })
        }
        reader.readAsDataURL(file)
      }
      // ファイルは拡張子からサムネイルを作成する
      else {
        vm.slides.push({
          isNew: true,
          file_index: file_index,
          name: file.name,
          size: file.size
        })
      }
    },
    // 表示：スライド
    slideTo (e, index) {
      if (index >= 0 && index < this.slides.length) {
        this.activeIndex = index
      }
    },
    getNavItemClassName (index) {
      return {
        active: index === this.activeIndex,
        main: this.type === 'image' && index === this.mainImageIndex
      }
    },
    getSlideItemClassName (index) {
      let className = this.getNavItemClassName(index)
      className.prevActive = index === this.activeIndex - 1
      className.nextActive = index === this.activeIndex + 1

      // 回転スタイル用
      const slide = this.slides[index]
      if (slide.rotate) {
        className.rotating = true
        className['rotating-' + slide.rotate] = true
      }

      return className
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
.bcard-file-droppable {
  position: relative;
  height: 300px; // 各画面で上書き可能
  margin: 3px;

  overflow: hidden;
  text-align: center;
  // color: #fff;
  background: $gray-lighter;
  box-sizing: border-box;

  &.-droppable {
    border: 2px dashed $gray-light;
    outline: 3px solid $gray-lighter;
  }

  &.-dragover {
    background-color: $state-info-bg;
  }

  // 説明文
  .message {
    margin: 0;
    position: absolute;
    top: 40px;
    left: 20px;
    right: 20px;
    bottom: 40px;
    display: block;
    cursor: pointer;
  }

  // ファイル選択
  span.sel-file {
    color: $brand-primary;
    text-decoration: underline;
  }
  input {
    position: absolute;
    // left: -9999px;
    z-index: -1; // requiredメッセージを表示するため、画面外に移動しないで、裏面に隠す

    &#_files {
      width: 100%;
    }
  }

  // ナビゲーション
  .carousel-indicators {
    bottom: -5px;
    li {
      width: 18px;
      height: 18px;
      border-color: #fff;
      background-color: #ccc;
      &.main {
        background-color: $brand-warning;
      }
      &.active {
        width: 20px;
        height: 20px;
        border-color: #fff;
        background-color: $component-active-bg;
      }
    }
  }
  // 左右移動
  .carousel-control {
    i {
      width: 40px;
      height: 40px;

      background-color: $component-active-bg;
      border-radius: 100%;

      // background-color: $component-active-bg;
    }
    &.left > i {
      left: 0;
    }
    &.right > i {
      right: 0;
    }
  }
  .order {
    position: absolute;
    top: 7px;
    background: #fff;
    height: 1.8em;
    line-height: 1.8em;
    width: 1.8em;
    border-radius: 100%;
    z-index: 1;
    margin-left: 10px;
    left: 15%;
  }

  // 配置関係
  .slide {
    height: 100%;
    padding: 40px 20px;
    .carousel-inner {
      position: relative;
      overflow: visible;
      height: 100%;

/*      border: 1px solid $list-group-border;*/
      background-color: $list-group-border;
      .item {
        align-items: center;
        height: 100%;
        transition: unset; /* IEでbootstrapのanimationが効いてしまうので追加 */
        .image {
          flex: 0 0 auto; /* IEバグ対応 https://stackoverflow.com/a/43227016 */
          /*justify-content: center;*/
          margin: 0 auto;
          max-height: calc(100% - 20px); /* outline分を引く */
          max-width: calc(100% - 20px); /* outline分を引く */

          .icon {
            padding: .5em;
            background-color: #fff;
            border: 2px solid #ccc;
            display: inline-block;
            vertical-align: middle;
            border-radius: 10px;
            font-size: 2em;
          }
        }

        &.rotating {
          position: relative;
          &:before {
            padding-top: 100%;

            content: '';
            display: block;
          }
          .image {
            position: absolute;
            top: 50%;
            left: 50%;

            transform-origin: top left;
          }
        }

        &.rotating-90 .image {
          max-width: 176px;

          transform: rotate(90deg) translate(-50%,-50%);
        }
        &.rotating-180 .image {
          transform: rotate(180deg) translate(-50%,-50%);
        }
        &.rotating-270 .image {
          max-width: 176px;

          transform: rotate(270deg) translate(-50%,-50%);
        }

        &.main .image {
          outline: 10px solid $brand-warning;
        }
        &.active img.zoomable {
          cursor: pointer;
        }
        &.active, &.prevActive, &.nextActive {
          display: flex;
        }
        &.prevActive, &.nextActive {
          position: absolute;
          top: 0;
          width: 100%;
        }
        &.prevActive {
          right: 105%;
          .image {
            /*justify-content: flex-end;*/
            margin: 0 0 0 auto;
          }
        }
        &.nextActive {
          left: 105%;
          .image {
            /*justify-content: flex-start;*/
            margin: 0 auto 0 0;
          }
        }
      }
      .rep {
        width: 150px;
        margin-left: -75px;
        position: absolute;
        top: -36px;
        left: 50%;
        z-index: 1;
      }
      .remove, .rotate {
        position: absolute;
        top: -33px;
        background: #fff;
        border-radius: 100%;
        z-index: 1;
        right: 10px;
      }
      .rotate {
        right: 40px;
      }
/*      .sort {
        position: absolute;
        bottom: -1.5em;

        z-index: 1;
        &.sort-left {
          left: -5%;
        }
        &.sort-right {
          right: -5%;
        }
      }*/
    }
  }
}
.order-items {
  .item.main {
    border-color: $brand-warning;
    background-color: $brand-warning;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/FileDroppable.vue